var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import React from "react";
var SvgDoubleArrowRight = function SvgDoubleArrowRight(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 20,
    height: 20
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    fill: "#C1C1C1",
    className: "fill-colored-el",
    d: "M15.002 10.666l-3.758 2.505A.8.8 0 0110 12.505v-5.01a.8.8 0 011.244-.666l3.758 2.505a.8.8 0 010 1.332zm-6 0L5.244 13.17A.8.8 0 014 12.505v-5.01a.8.8 0 011.244-.666l3.758 2.505a.8.8 0 010 1.332z",
    fillRule: "evenodd"
  })));
};
export default SvgDoubleArrowRight;